// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"272":"pdfmake","868":"xlsx"}[chunkId] || chunkId) + "." + {"272":"16c324da","592":"56b2bfdd","868":"1210da1f"}[chunkId] + ".chunk.js";
};